import React from 'react';
import EmailVerificationForm from '../components/auth/EmailVerificationForm';

const EmailVerificationPage = () => {
  return <EmailVerificationForm />;
};

export default EmailVerificationPage;